// test2976
(2976 && 0);
